/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  CORRELATION_ID_HEADER,
  IMPERSONATION_HEADER,
  MonolithService,
} from '@zorro/clients';
import { tryGetHeader } from '@zorro/common-utils';
import { EndpointCall } from '@zorro/web/ui-utils';
import { NextApiRequest, NextApiResponse } from 'next';
import { v4 as uuidv4 } from 'uuid';

import { withApi, withApiSession } from './session';

function isImpersonatedReferer(referer?: string): boolean {
  try {
    return Boolean(
      referer && new URL(referer).searchParams.get('impersonatedEmployeeId')
    );
  } catch {
    return false;
  }
}

export async function monolithClientHandler(
  req: NextApiRequest,
  res: NextApiResponse
) {
  // Ensure correlation ID propagates to downstream calls
  const correlationIdFromHeader = tryGetHeader(
    req.headers,
    CORRELATION_ID_HEADER
  );
  const correlationId = correlationIdFromHeader ?? uuidv4();
  req.headers[CORRELATION_ID_HEADER] = correlationId;

  // Derived here, never accepted from the caller: an impersonating tab carries
  // `impersonatedEmployeeId` in the page URL it calls from. Always overwritten
  // so a forged inbound header cannot reach the monolith.
  req.headers[IMPERSONATION_HEADER] = String(
    isImpersonatedReferer(tryGetHeader(req.headers, 'referer'))
  );

  async function apiHandler(monolithClient: MonolithService) {
    try {
      const { method, params } = req.body as EndpointCall;
      const response = await (monolithClient[method] as any)(...params);
      res.status(200).json(response);
    } catch (error) {
      res.status(error.status).json(error);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  req.body.anonymous
    ? await withApi(req, res, apiHandler)
    : await withApiSession(req, res, apiHandler);
}
